import { render } from "./ConfirmAppointment.vue?vue&type=template&id=40e79a68&scoped=true&ts=true"
import script from "./ConfirmAppointment.vue?vue&type=script&lang=ts"
export * from "./ConfirmAppointment.vue?vue&type=script&lang=ts"

import "./ConfirmAppointment.vue?vue&type=style&index=0&id=40e79a68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e79a68"]])

export default __exports__